// extracted by mini-css-extract-plugin
export default {"colorPickerPaper":"ColorPicker_colorPickerPaper__Bwpw7","colorPickerRgbInput":"ColorPicker_colorPickerRgbInput__9Xn81"};